module.exports = __webpack_public_path__ + "static/media/storytelling.38e5da18.jpg";